import axios from 'axios';
import { configRefs } from '@utils/constants';

async function shareRevisionRequest(user, revision, userIds, teamIds) {
  if (!user || !user.institution?.id) {
    throw new Error("shareRevisionRequest(): missing user data");
  }
  if (!revision.__syncedWithBackend) {
    throw new Error("shareRevisionRequest(): revision is not present in the backend");
  }
  const requestBody = (() => {
    const base = {
      userID: user.id,
      userInstitutionID: user.institution.id
    };
    if ((userIds?.length ?? 0) > 0) {
      return {
        ...base,
        sharedWithUsers: userIds,
        sharedWithTeams: []
      };
    }
    return {
      ...base,
      sharedWithUsers: [],
      sharedWithTeams: teamIds
    };
  })();
  await axios.post(`${await configRefs.apis.userdata.get()}/api/CourseRevisions/${encodeURIComponent(revision.id)}/Share`, requestBody);
  return;
}

export { shareRevisionRequest };
//# sourceMappingURL=request.share.js.map
